import baseRequest from '@/hooks/shopify-hooks/api/useRequest';
import { shopifyConst } from "@/hooks/shopify-hooks/useShopifyConst";
import { useDeliveryAddress } from '@/hooks/shopify-hooks/useDeliveryAddress';
import { useIsEurope } from '@/hooks/shopify-hooks/useDeliveryAddress';
const { countryIsoCode = '', languageIsoCode = 'en' } = shopifyConst;
const languageCode = languageIsoCode.toUpperCase();

const inContext = `, $country: CountryCode!, $language: LanguageCode!) 
@inContext(country: $country, language: $language`;

const cartDeliveryFragments = `delivery {
                addresses {
                id
                selected
                oneTimeUse
                address {
                    ... on CartDeliveryAddress {
                    firstName
                    lastName
                    company
                    address1
                    address2
                    city
                    provinceCode
                    zip
                    countryCode
                    }
                }
                }
            }
          deliveryGroups(first: 10) {
            nodes {
                id
                deliveryOptions {
                handle
                title
                estimatedCost { amount }
                }
                selectedDeliveryOption { handle }
            }
          }`;

// 创建购物车
export const useCreateCart = async (cartInput) => {
  try {
    const query = `mutation createCart($cartInput: CartInput${inContext}) {
        cartCreate(input: $cartInput) {
          cart {
            id
            createdAt
            updatedAt
            checkoutUrl
            totalQuantity
            lines(first: 100) {
              edges {
                node {
                    id
                  quantity
                  attributes {
                    key
                    value
                  }
                  cost {
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                    targetType
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
            attributes {
              key
              value
            }
            cost {
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }
    `;
    const variables = {
      cartInput: cartInput,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======useCreateCart======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 创建B2B购物车
export const useCreateB2BCart = async (cartInput, buyerIdentity) => {
  try {
    const query = `
      mutation createCart($cartInput: CartInput) {
        cartCreate(input: $cartInput) {
          cart {
            id
            createdAt
            updatedAt
            checkoutUrl
            lines(first: 100) {
              edges {
                node {
                    id
                  quantity
                  attributes {
                    key
                    value
                  }
                  cost {
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                    }
                  }
                }
              }
            }
            attributes {
              key
              value
            }
            buyerIdentity {
              email
              customer {
                id
              }
              purchasingCompany {
                location {
                  id
                }
              }
            }
            cost {
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }
    `;
    const variables = {
      cartInput: {
        ...cartInput,
        buyerIdentity
      }
    };
    const response = await baseRequest(query, variables);

    console.log('======useCreateCart======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 查询购物车
export const useQueryCart = async (cartId) => {
  try {
    const query = `query cartQuery($cartId: ID!${inContext})
      {
        cart(id: $cartId) {
          id
          createdAt
          updatedAt
          totalQuantity
          checkoutUrl
          lines(first: 100) {
            edges {
              node {
                  id
                quantity
                attributes {
                  key
                  value
                }
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                  compareAtAmountPerQuantity {
                    amount
                    currencyCode
                  }
                }
                discountAllocations {
                  discountedAmount {
                    amount
                    currencyCode
                  }
                  targetType
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    availableForSale
                    quantityAvailable
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                    price {
                      amount
                      currencyCode
                    }
                    requiresShipping
                    title
                    image {
                      id
                      url
                      altText
                      width
                      height
                    }
                    product {
                      handle
                      title
                      id
                      tags
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
          attributes {
            key
            value
          }
          cost {
            totalAmount {
              amount
              currencyCode
            }
            subtotalAmount {
              amount
              currencyCode
            }
            totalTaxAmount {
              amount
              currencyCode
            }
            totalDutyAmount {
              amount
              currencyCode
            }
          }
          buyerIdentity {
            email
            phone
            customer {
              id
            }
            countryCode
            purchasingCompany {
              location {
                id
              }
            }
          }
          discountCodes {
            code
            applicable
          }
          discountAllocations {
              discountedAmount {
                amount
                currencyCode
              }
              targetType
          }
          ${cartDeliveryFragments}
        }
      }
    `;
    const variables = {
      cartId,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);
    const cartData = response?.data?.cart;
    if (cartData) {
      isAddDeliveryAddress(cartData)
    }
    console.log('======useQueryCart======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 加入购物车
export const useAddCartLines = async (cartId, lines) => {
  try {
    const query = `
    mutation addCartLines($cartId: ID!, $lines: [CartLineInput!]!${inContext}) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            id
            totalQuantity
            lines(first: 100){
              edges
              {
                node{
                id
                  quantity
                  attributes {
                    key
                    value
                  }
                  cost {
                    totalAmount {
                      amount
                      currencyCode
                    }
                    compareAtAmountPerQuantity {
                      amount
                      currencyCode
                    }
                  }
                  discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                    targetType
                  }
                  merchandise{
                    ... on ProductVariant {
                      id
                    }
                  }
                }
              }
            }
            buyerIdentity {
              email
              phone
              customer {
                id
              }
              countryCode
              purchasingCompany {
                location {
                  id
                }
              }
            }
            cost {
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
            ${cartDeliveryFragments}
          }
          
          
          userErrors {
            field
            message
          }
        }
      }
    `;
    const variables = {
      cartId,
      lines,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======useAddCartLines======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 更新购物车（商品数量增减、商品参数）
export const useUpdateCartLines = async (cartId, lines) => {
  try {
    const query = `
        mutation updateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!${inContext}) {
          cartLinesUpdate(cartId: $cartId, lines: $lines) {
            cart {
                id
                createdAt
                updatedAt
                totalQuantity
                checkoutUrl
                lines(first: 100) {
                  edges {
                    node {
                      id
                      quantity
                      attributes {
                        key
                        value
                      }
                      cost {
                        totalAmount {
                          amount
                          currencyCode
                        }
                        compareAtAmountPerQuantity {
                          amount
                          currencyCode
                        }
                      }
                      discountAllocations {
                        discountedAmount {
                          amount
                          currencyCode
                        }
                        targetType
                      }
                      merchandise {
                        ... on ProductVariant {
                          id
                          availableForSale
                          quantityAvailable
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                          price {
                            amount
                            currencyCode
                          }
                          requiresShipping
                          title
                          image {
                            id
                            url
                            altText
                            width
                            height
                          }
                          product {
                            handle
                            title
                            id
                            tags
                          }
                          selectedOptions {
                            name
                            value
                          }
                        }
                      }
                    }
                  }
                }
                attributes {
                  key
                  value
                }
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalTaxAmount {
                    amount
                    currencyCode
                  }
                  totalDutyAmount {
                    amount
                    currencyCode
                  }
                }
                buyerIdentity {
                  email
                  phone
                  customer {
                    id
                  }
                  countryCode
                  purchasingCompany {
                    location {
                      id
                    }
                  }
                }
                discountCodes {
                  code
                  applicable
                }
                discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                    targetType
                    # Specific fields tailored to the discount type
                    ... on CartAutomaticDiscountAllocation {
                      title
                    }
                    ... on CartCustomDiscountAllocation {
                      title
                    }
                    ... on CartCodeDiscountAllocation {
                      code
                    }
                }
                ${cartDeliveryFragments}
              }
            }
          }
    `;
    const variables = {
      cartId,
      lines,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======useUpdateCartLines======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 移除购物车某行商品
export const useRemoveCartLines = async (cartId, lineIds) => {
  try {
    const query = `
        mutation removeCartLines($cartId: ID!, $lineIds: [ID!]!${inContext}){
          cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
            cart {
                id
                createdAt
                updatedAt
                totalQuantity
                checkoutUrl
                lines(first: 100) {
                  edges {
                    node {
                      id
                      quantity
                      attributes {
                        key
                        value
                      }
                      cost {
                        totalAmount {
                          amount
                          currencyCode
                        }
                        compareAtAmountPerQuantity {
                          amount
                          currencyCode
                        }
                      }
                      discountAllocations {
                        discountedAmount {
                          amount
                          currencyCode
                        }
                      }
                      merchandise {
                        ... on ProductVariant {
                          id
                          availableForSale
                          quantityAvailable
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                          price {
                            amount
                            currencyCode
                          }
                          requiresShipping
                          title
                          image {
                            id
                            url
                            altText
                            width
                            height
                          }
                          product {
                            handle
                            title
                            id
                            tags
                          }
                          selectedOptions {
                            name
                            value
                          }
                        }
                      }
                    }
                  }
                }
                attributes {
                  key
                  value
                }
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalTaxAmount {
                    amount
                    currencyCode
                  }
                  totalDutyAmount {
                    amount
                    currencyCode
                  }
                }
                buyerIdentity {
                  email
                  phone
                  customer {
                    id
                  }
                  countryCode
                  purchasingCompany {
                    location {
                      id
                    }
                  }
                }
                discountCodes {
                  code
                  applicable
                }
                discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                    targetType
                    # Specific fields tailored to the discount type
                    ... on CartAutomaticDiscountAllocation {
                      title
                    }
                    ... on CartCustomDiscountAllocation {
                      title
                    }
                    ... on CartCodeDiscountAllocation {
                      code
                    }
                }
                ${cartDeliveryFragments}
              }
            }
          }
    `;
    const variables = {
      cartId,
      lineIds,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======useRemoveCartLines======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 使用折扣码
export const useUpdateCartDiscountCodes = async (cartId, discountCodes) => {
  try {
    const query = `
        mutation updateCartDiscountCodes($cartId: ID!, $discountCodes: [String!]!${inContext}) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart {
                id
                createdAt
                updatedAt
                totalQuantity
                checkoutUrl
                lines(first: 100) {
                  edges {
                    node {
                      id
                      quantity
                      attributes {
                        key
                        value
                      }
                      cost {
                        totalAmount {
                          amount
                          currencyCode
                        }
                        compareAtAmountPerQuantity {
                          amount
                          currencyCode
                        }
                      }
                      discountAllocations {
                        discountedAmount {
                          amount
                          currencyCode
                        }
                      }
                      merchandise {
                        ... on ProductVariant {
                          id
                          availableForSale
                          quantityAvailable
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                          price {
                            amount
                            currencyCode
                          }
                          requiresShipping
                          title
                          image {
                            id
                            url
                            altText
                            width
                            height
                          }
                          product {
                            handle
                            title
                            id
                            tags
                          }
                          selectedOptions {
                            name
                            value
                          }
                        }
                      }
                    }
                  }
                }
                attributes {
                  key
                  value
                }
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalTaxAmount {
                    amount
                    currencyCode
                  }
                  totalDutyAmount {
                    amount
                    currencyCode
                  }
                }
                buyerIdentity {
                  email
                  phone
                  customer {
                    id
                  }
                  countryCode
                  purchasingCompany {
                    location {
                      id
                    }
                  }
                }
                discountCodes {
                  code
                  applicable
                }
                discountAllocations {
                    discountedAmount {
                      amount
                      currencyCode
                    }
                    targetType
                    # Specific fields tailored to the discount type
                    ... on CartAutomaticDiscountAllocation {
                      title
                    }
                    ... on CartCustomDiscountAllocation {
                      title
                    }
                    ... on CartCodeDiscountAllocation {
                      code
                    }
                }
                ${cartDeliveryFragments}
              }
            }
          }
    `;
    const variables = {
      cartId,
      discountCodes,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======useRemoveCartLines======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

// 查询checkoutURL
export const useQueryCheckoutURL = async (cartId) => {
  try {
    const query = `
      query checkoutURL($cartId: ID!${inContext}) {
        cart(id: $cartId) {
          checkoutUrl
          totalQuantity
        }
      }
    `;
    const variables = {
      cartId,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======useQueryCheckoutURL======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}


// 更新购物车信息，为了解决商品改价，购物车显示价格不更新的问题
export const useUpdateCart = async (cart) => {
  const lines = cart.lines?.edges?.map(item => {
    return {
      attributes: item?.node?.attributes,
      id: item?.node?.id,
      quantity: item?.node?.quantity === 0 ? 1 : item?.node?.quantity  // 这是为了解决库存为0的商品刷新购物车不删掉
    }
  });
  const res = await useUpdateCartLines(cart.id, lines);
  return res;
}


// 更新购物车信息，为了解决商品改价，购物车显示价格不更新的问题
export const useTsbUpdateCart = async (cart) => {
  const lines = cart.lines?.edges?.map(item => {
    return {
      attributes: item?.node?.attributes,
      id: item?.node?.id,
      quantity: item?.node?.quantity === 0 ? 1 : item?.node?.quantity,
    }
  });
  const res = await useUpdateCartLines(cart.id, lines);
  return res;
}

// 给购物车增加配送地址
export const useCartDeliveryAddressesAdd = async (cartId) => {
  try {
    const query = `mutation CartDeliveryAddressesAdd($id: ID!, $addresses: [CartSelectableAddressInput!]!${inContext}) {
      cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {
        userErrors {
          message
          code
          field
        }
        warnings {
          message
          code
          target
        }
        cart {
          id
          delivery {
            addresses {
              id
              selected
              oneTimeUse
              address {
                ... on CartDeliveryAddress {
                  firstName
                  lastName
                  company
                  address1
                  address2
                  city
                  provinceCode
                  zip
                  countryCode
                }
              }
            }
          }
        }
      }
    }`
    const addresses = useDeliveryAddress();
    console.log("===addresses", addresses);
    const variables = {
      id: cartId,
      addresses,
      language: languageCode,
      country: countryIsoCode
    };
    const response = await baseRequest(query, variables);

    console.log('======CartDeliveryAddressesAdd======', response)
    return response?.data;
  } catch (e) {
    throw new Error(e);
  }
}

export const isAddDeliveryAddress = (cartData) => {
  if (useIsEurope()) {
    if (cartData?.delivery?.addresses?.length === 0) {
      useCartDeliveryAddressesAdd(cartData.id);
    }
  }
}